import React from 'react';
import Markdown from 'react-markdown';
import './style.scss';

import Button from '../Button/Button';

import { createHero, mapHeroProps } from '../hero';
import { getImageUrl, getVideoSources } from '../../utils/helpers';

const HeroCompact = ({ data, heroCreate }) => {
  const hero = heroCreate
    ? createHero(heroCreate.title, heroCreate.subtitle, heroCreate.background)
    : mapHeroProps(data);
  const bgImage = getImageUrl(hero.backgroundHash);
  return (
    <section className='hero-s__container pt-64 lg:pt-0'>
      {hero.backgroundType === 'VIDEO' && (
        <video
          width='100%'
          controls={false}
          autoPlay
          muted
          playsInline
          loop
          className='hero-s__bg'
        >
          {getVideoSources(hero.backgroundHash)}
        </video>
      )}
      {hero.backgroundType === 'IMAGE' && (
        <img
          src={getImageUrl(hero.backgroundHash, 'co_rgb:052A2D,e_colorize:67')}
          alt='Hero background'
          className='hero-s__bg'
        />
      )}
      <div className='hero-s__content container'>
        <Markdown>{hero.primaryText}</Markdown>
        <p className='whitespace-pre-line'>{hero.secondaryText}</p>
      </div>
    </section>
  );
};

export default HeroCompact;
